class ObjectStorage {
  constructor(storageKey) {
    this.storageKey = storageKey
  }

  all() {
    return this._getStorage()
  }

  get(key) {
    return this._getStorage()[key]
  }

  add(key, value) {
    const storedValue = this._getStorage()
    const newValue = { ...storedValue, [key]: value }
    this._write(newValue)
    return this
  }

  remove(key) {
    const { [key]: _, ...newValue } = this._getStorage()
    this._write(newValue)
  }

  _getStorage() {
    try {
      const item = window.localStorage.getItem(this.storageKey)
      return item ? JSON.parse(item) : {}
    } catch {
      return {}
    }
  }

  _write(value) {
    window.localStorage.setItem(this.storageKey, JSON.stringify(value))
  }
}

export default storageKey => new ObjectStorage(storageKey)
